import styled, {css} from 'react-emotion';
import {queries} from './mediaQueries';
import theme from "./theme";

export const modal = css`
    z-index: 10;
    position: absolute;
    width: 900px;
    left: 50%;
    transform: translate(-50%, 0%);
    top: 40px;
    bottom: 40px;
    border: 1px solid #ccc;
    background: #fff;
    overflow: auto;
    /*-webkit-overflow-scrolling: touch;*/
    border-radius: 4px;
    outline: none;
    padding: 20px;
    box-shadow: 0px 2px 3px 0px grey;
    ${queries.xxLarge` 
		right: 40px;
		left: 40px;
		width: auto;
		transform: translate(0%, 0%);
    `};
    ${queries.xLarge`
        right: 10px;
		left: 10px;
		width: auto;
		transform: translate(0%, 0%);
    `};
`;

export const modalOverlay = css`
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.75);
`;

export const tableBase = css`
    /* remove the box-shadow for sorted columns */
    .rt-thead .rt-th.-sort-asc, .rt-thead .rt-td.-sort-asc {
        box-shadow: none !important;
        -webkit-box-shadow: none !important;
    }

    .rt-thead .rt-th.-sort-desc, .rt-thead .rt-td.-sort-desc {
        box-shadow: none !important;
        -webkit-box-shadow: none !important;
    }
    
    .ReactTable .rt-td {
        overflow: auto;
        whiteSpace: normal;
        max-height: 100px;
    }
`;

export const icon = css`
    cursor: pointer;
    color: ${theme.colors.secondaryColor};
    margin: 5px;
    transition: color 0.3s, box-shadow 0.3s;
    & :hover {
        filter: brightness(150%);
    }
`;

export const TableExpander = styled.div`
    color: ${props => props.isExpanded ? theme.colors.primaryColor : theme.colors.secondaryColor};
    -webkit-transform: rotate(${props => props.isExpanded ? "90deg" : "0deg"});
    transform: rotate(${props => props.isExpanded ? "90deg" : "0deg"});
    -webkit-transition: color 0.3s, transform 0.3s;
    transition: color 0.3s, transform 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const TableNonExpander = styled.div`
    cursor: default;
    display: block;
    align-items: center;
    justify-content: center;
    margin: -7px -5px;
    padding: 7px 5px;
    flex: 1;
    height: 28px;
    width: 28px;
`;

export const Name = styled.div`
	color: ${theme.colors.secondaryColor};
	text-decoration: none;
	font-weight: bold;
	font-size: 1.0rem;
`;

export const TableLike = styled.div`
    section {
      display: table;
    }
    
    header,
    .line-break,
    .row {
      display: table-row;
    }
    
    .col {
      display: table-cell;
      padding: 3px;
    }   
`;


// WEBPACK FOOTER //
// ./src/styles/Details.js